export default __webpack_public_path__ + "static/media/arrow-bottom-black.498ebdf1.svg";